var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigateKeepSession } from "../../tools/useNavigateKeepSession";
import ChatComponent from "../../components/ChatComponent";
import { useEffect, useState } from "react";
import SetOfButtonsPlayerComponent from "../../components/player_game_element_component/SetOfButtonsPlayerComponent";
import useSessionContext from "../../tools/useSessionContext";
import useMedia from "../../contexts/useMedia";
import { ETeam } from "cresus-common";
import { useBoardGame } from "../../contexts/BoardGameProvider";
const defaultPlayerDTO = {
    micOn: false,
    name: "",
    avatarComposition: {
        teamColor: ETeam.RED,
        skin: 0,
        hair: 0,
        hair_color: 0,
        eyes: 0,
        nose: 0,
        mouth: 0,
        bonus: 0,
    },
    team: ETeam.RED,
    capitain: false,
    sessionPeerId: "",
    isConnected: true,
};
// small helper
const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
function IntroductionPlayerPage() {
    const { muteSound } = useBoardGame();
    const { setCameraMode, audioVideoClient } = useMedia();
    const { gameState, sendRequest, websocketPeer } = useSessionContext();
    const [myPlayer, setMyPlayer] = useState();
    const [insideGameState, setInsideGameState] = useState(gameState);
    const [isChatShown, setIsChatShown] = useState(false);
    const [newMessageAlert, setNewMessageAlert] = useState(false);
    const navigate = useNavigateKeepSession();
    /**
     * STABILITY FIX #1:
     * This effect previously ran on every render (no dependency array),
     * which can create render thrashing and timing/race issues.
     * We only want to do this when the page mounts or when the client instance changes.
    //  */
    // useEffect(() => {
    //   audioVideoClient.unmuteMic();
    //   setCameraMode(true, false, false);
    // }, [audioVideoClient, setCameraMode]);
    // const lastPeerRef = useRef<any>(null);
    useEffect(() => {
        console.log("one");
        if (!websocketPeer)
            return;
        // // Only guard duplicate runs for the SAME peer instance
        // if (lastPeerRef.current === websocketPeer) return;
        // lastPeerRef.current = websocketPeer;
        let cancelled = false;
        console.log("two");
        (() => __awaiter(this, void 0, void 0, function* () {
            try {
                muteSound("GlobalAmbiance");
                // 1) Rehydrate first
                const freshState = yield sendRequest("onConnectionOrReaload", {
                    gameState,
                });
                if (cancelled)
                    return;
                const baseState = freshState !== null && freshState !== void 0 ? freshState : gameState;
                setInsideGameState(baseState);
                // 2) Try auto-rejoin if name exists
                const name = sessionStorage.getItem("playerName");
                console.log("name", name);
                let stateAfterJoin = baseState;
                console.log("baseState", baseState);
                if (name) {
                    const playerTest = defaultPlayerDTO;
                    playerTest.name = name;
                    const joinResult = yield sendRequest("joinAsPlayer", {
                        player: playerTest,
                    });
                    // const joinResult = await sendRequest("joinLobby", {
                    //   playerNameToSend: name,
                    // });
                    console.log("joinResult", joinResult);
                    if (joinResult) {
                        stateAfterJoin = joinResult;
                        setInsideGameState(joinResult);
                        sessionStorage.setItem("playerName", name);
                    }
                    else {
                        navigate("/ReconnectionPage");
                        return;
                    }
                }
                else {
                    navigate("/ReconnectionPage");
                    return;
                }
                // 3) Now fetch my player using the best-known state
                const me = yield sendRequest("getMyPlayer", {
                    gameState: stateAfterJoin,
                });
                console.log("test me", me);
                if (!cancelled)
                    setMyPlayer(me);
            }
            catch (e) {
                if (!cancelled)
                    navigate("/ReconnectionPage");
                console.error("Init/auto-rejoin failed", e);
            }
        }))();
        return () => {
            cancelled = true;
        };
    }, [websocketPeer, sendRequest, muteSound, navigate]);
    /**
     * STABILITY FIX #2 (WebSocket subscription):
     * Subscribe once per websocketPeer instance, and ALWAYS unsubscribe on cleanup.
     *
     * Why deps are safe here:
     * - Dependency is only the emitter instance (websocketPeer).
     * - If you reconnect and websocketPeer changes, you resubscribe correctly.
     *
     * Also: use functional setState to avoid stale closure on insideGameState.
     */
    useEffect(() => {
        if (!websocketPeer)
            return;
        const onNotification = (notification) => {
            if (notification.method === "startAvatarSelection") {
                setInsideGameState((prev) => (Object.assign(Object.assign({}, prev), { avatarSelectionOn: notification.data.avatarSelectionOn })));
            }
        };
        websocketPeer.on("notification", onNotification);
        return () => {
            // Different event emitter implementations use different APIs
            if (typeof websocketPeer.off === "function") {
                websocketPeer.off("notification", onNotification);
            }
            else if (typeof websocketPeer.removeListener === "function") {
                websocketPeer.removeListener("notification", onNotification);
            }
        };
    }, [websocketPeer]);
    /**
     * UI behavior: toggling chat
     */
    function toggleChat() {
        setIsChatShown((prev) => {
            const next = !prev;
            // If opening chat, clear "new message" indicator
            if (!prev)
                setNewMessageAlert(false);
            return next;
        });
    }
    /**
     * STABILITY FIX #3:
     * Depend on the specific field you care about instead of the entire object,
     * to avoid unnecessary re-navigation triggers.
     */
    useEffect(() => {
        if (insideGameState.avatarSelectionOn)
            navigate("/AvatarCompositionPage");
    }, [insideGameState.avatarSelectionOn, navigate]);
    return (_jsxs("div", Object.assign({ className: "flex fixed flex-col justify-start items-center h-screen w-screen", style: {
            paddingTop: "50px",
            paddingLeft: "40px",
            paddingRight: "40px",
        } }, { children: [_jsxs("div", Object.assign({ className: "flex gap-[50px] justify-between flex-col h-full relative pb-[10px]" }, { children: [_jsx("div", { className: "flex dilemeLogo", style: {
                            backgroundImage: "url(./assets/UI/logos/dilemme_education.png)",
                            backgroundSize: "contain",
                            backgroundRepeat: "no-repeat",
                            minHeight: 166,
                            minWidth: 420,
                            maxHeight: 166 * 2,
                            maxWidth: 420 * 2,
                            zIndex: 0,
                        } }), _jsx(SetOfButtonsPlayerComponent, { alertNewMessage: newMessageAlert, toggleChat: toggleChat, isMapModifiable: false, isOnlyConfigButton: false })] })), myPlayer && (_jsx(ChatComponent, { newMessageAlert: setNewMessageAlert, isChatShown: isChatShown, toggleChat: toggleChat, myPlayer: myPlayer }))] })));
}
export default IntroductionPlayerPage;
